import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { useGeoState, useGeoFetch } from '../../../components/GeoProvider'
import ErrorMessage from '../../../components/Layout/ErrorMessage'
import DisplayDateProvider from '../../../components/DisplayDateProvider/DisplayDateProvider'
import Spinner from '../../../components/Loader/Spinner'
import EmptyMap from '../../../components/Map/emptyMap'
import MapLegend from './../cdcMapLegend8LevelHorizontal'
import SideTableProvider from './SideTableProvider'
import styles from './MapPage.module.scss'
import ProviderDetails from './ProviderDetails'
import ErrorLogs from '../../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../../components/AuthProvider'
import ProviderMapMarker from '../../FluDashboard/ProviderMapMarker'
import { lastweekEndDate } from './../dates'
const DashboardMap = ({ geo_type, geo_parent, zoomLocation }) => {
  const { user } = useAuthState()
  const chartRef = useRef(null)
  const geojson = useRef(null)
  //const lastweekEndDate = dayjs().day(+6).format('YYYY-MM-DD')
  // const entity = 'flu'
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const location = useLocation()
  const { loc, area } = useParams()
  const hash = location.hash
  const [getMapStates, setMapStates] = useState()
  const [metros, setMetros] = useState()
  const [activeCbsa, setActiveCbsa] = useState()
  const [getStats, setStats] = useState()
  const [getStatsAll, setStatsAll] = useState()
  // const [showProvidersMap, setshowProvidersMap] = useState(false)
  const [getProviderDropDown, setProviderDropDown] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getCBSAJsonData, setCBSAJsonData] = useState()
  const [getStateJson, setStateJson] = useState()
  const [getforecast_level, setforecast_level] = useState()
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    showProvidersMap,
  } = useGeoState()
  const [getProvider, setProvider] = useState()

  if (area === 'msa') {
    setRegionSelected(area)
  }
  const { data: statesData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'rsvmap',
    'STATE/?geo_parent=US'
  )

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        setMapStates(statesData.response_data)
      } else {
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statesData])

  const { data: msaData, error: MapmsaError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'rsvmap',
    'MSA/?geo_parent=' + geo_parent
  )
  const { data: msaData1, error: MapmsaError1 } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'fluMapThreshold',
    `MSA/?geo_parent=${geo_parent}&geoid=${loc}&disease=rsv`
  )

  useEffect(() => {
    if (msaData1 !== null && msaData1 !== undefined) {
      if (msaData1.response_code === 200) {
        setforecast_level(msaData1.response_data)
        // setMetros(msaData.response_data)        
        // var data = Object(msaData.response_data)[lastweekEndDate][parseInt(loc)].forecast_level
        // setforecast_level(data)
      } else {
        //setforecast_level(msaData1.response_data)
        setErrorCode(msaData1.response_code)
        setErrorMessage(msaData1.response_message)
        setErrorSubject(msaData1.response_subject)
        seterrorOccured(true)
      }
    }
  }, [msaData1])

  // Active Metro Areas
  const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'rsvLocations',
    'activelocations?geo_type=MSA&geo_parent_code=' + geo_parent
  )

  useEffect(() => {
    if (activeCbsasData !== null && activeCbsasData !== undefined) {
      setActiveCbsa(activeCbsasData)
    }
  }, [activeCbsasData])

  let type = hash.length > 0 ? hash.replace('#', '') : ''
  const { data: stats, error: stateDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'rsvProviders',
    geo_parent + `/${loc}?disease_type=RSV&filter=${type}`
  )

  useEffect(() => {
    if (stats !== null && stats !== undefined) {
      if (stats.response_code === 200) {
        setStats(stats.response_data)
      } else {
        setErrorCode(stats.response_code)
        setErrorMessage(stats.response_message)
        setErrorSubject(stats.response_subject)
        seterrorOccured(true)
      }
    }
  }, [stats])

  const { data: statsall, error: stateallDataError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'rsvProviders',
    `US/${geo_parent}?disease_type=RSV&filter=${type}`
  )

  useEffect(() => {
    if (statsall !== null && statsall !== undefined) {
      if (statsall.response_code === 200) {
        setStatsAll(statsall.response_data)
      } else {
        setErrorCode(statsall.response_code)
        setErrorMessage(statsall.response_message)
        setErrorSubject(statsall.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statsall])

  const { data: providerDropDown, error: dropdownError } = useGeoFetch(
    lastweekEndDate,
    lastweekEndDate,
    'rsvProvidersFilter',
    geo_parent + `/${loc}`
  )
  useEffect(() => {
    if (providerDropDown !== null && providerDropDown !== undefined) {
      if (providerDropDown.response_code === 200) {
        setProviderDropDown(providerDropDown.response_data)
      } else {
        setErrorCode(providerDropDown.response_code)
        setErrorMessage(providerDropDown.response_message)
        setErrorSubject(providerDropDown.response_subject)
        seterrorOccured(true)
      }
    }
  }, [providerDropDown])

  useEffect(() => {
    let url = `${window.location.origin}/rsv/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/rsv/cb_2018_us_cbsa_20m_wkid102004.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setCBSAJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file us_hrr_values ')
      })
  }, [1])

  if (
    stateDataError ||
    MapError ||
    errorOccured ||
    MapmsaError ||
    activeCbsasDataError ||
    dropdownError ||
    stateallDataError
  ) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }
  const chooseMessage = (data) => {
    setProvider(data)
  }

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cbsasPanel}`}>
        <>
          {regionSelected === 'msa' && (
            <>
              {getStats !== undefined && getProviderDropDown !== undefined ? (
                <SideTableProvider
                  dropdownData={getProviderDropDown}
                  stateData={getStats}
                  chooseMessage={chooseMessage}
                  chartRef={chartRef}
                />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
        </>
      </div>
      <div className={`${styles.map}`}>
        {regionSelected === 'msa' && (
          <>
            {getforecast_level !== undefined &&
            getMapStates !== undefined &&
            activeCbsa !== undefined ? (
              <>
                {getProvider && (
                  <ProviderDetails
                    providerData={getProvider}
                    chooseMessage={chooseMessage}
                  />
                )}
               
                {!showProvidersMap && getStatsAll && getStats && (
                  <>
                    <div className={`${styles.providerHeaderCollection}`}>
                      <DisplayDateProvider
                       textShow={'CDO Locations for Epiweek '}
                        showWeek={true}
                        lastweekEndDate={lastweekEndDate}
                        statesData={getMapStates}
                      />
                    </div>
                    {getStats && getforecast_level &&  <MapLegend geojson={geojson} provider={true} thresholdVal={getforecast_level}  data_type="rsv" />}
                   {getforecast_level &&  <ProviderMapMarker  geojson={geojson} thresholdVal={getforecast_level}  providers={getStats} geoid={loc} data_type="rsv"  />}

                   
                    
                  </>
                )}
              </>
            ) : (
              <EmptyMap />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DashboardMap